export interface ReportingSubtabSectionFilters {
  startDate: string | null;
  endDate: string | null;
  dateRange: string | null;
};
export interface ReportingFilters {
  transStatus: string;
  displayView: string;
  querySearch: string | null;
  startDate: string | null;
  endDate: string | null;
  paginationPage: number;
  paginationPageSize: number;
  sortBy: string;
  sortDir: string;
  dateRange: string | null;
  uid: string | null;
};

export const ReportingFilterObjInit: ReportingFilters = {
  transStatus: 'wip',
  displayView: 'small',
  querySearch: null,
  startDate: null,
  endDate: null,
  paginationPage: 1,
  paginationPageSize: 10,
  sortBy: '',
  sortDir: '',
  dateRange: null,
  uid: null,
};

export const FilterObjInit: LandingFilters = {
  transStatus: 'all',
  transType: 'all',
  querySearch: null,
  startDate: null,
  endDate: null,
  filterBy: null,
  paginationPage: 1,
  paginationPageSize: 10,
  sortBy: null,
  sortDir: null,
  project: null,
  transactionStatus: '',
};

export interface LandingFilters {
  transStatus: string;
  transType: string;
  querySearch: string | null;
  startDate: string | null;
  endDate: string | null;
  filterBy: 'MTD' | 'QTD' | 'YTD' | null;
  paginationPage: number;
  paginationPageSize: number;
  sortBy: string | null;
  sortDir: string | null;
  project: string | null;
  transactionStatus?: string;
};

export interface ReportDetailFilters {
  reportId: number | null;
  displayView: string;
  querySearch: string;
  startDate: string;
  endDate: string;
  paginationPage: number;
  paginationPageSize: number;
  sortBy: string;
  sortDir: string;
  uid: string;
};

export const ReportDetailFilterObjInit: ReportDetailFilters = {
  reportId: null,
  displayView: '',
  querySearch: '',
  startDate: '',
  endDate: '',
  paginationPage: 1,
  paginationPageSize: 10,
  sortBy: '',
  sortDir: '',
  uid: '',
};
export interface CustomerLandingFilters {
  querySearch: string | null;
  paginationPage: number;
  paginationPageSize: number;
  sortBy: string | null;
  sortDir: string | null;
  uid: string | null;
};
export const CustomerLandingFilterObjInit: CustomerLandingFilters = {
  querySearch: null,
  paginationPage: 1,
  paginationPageSize: 10,
  sortBy: null,
  sortDir: null,
  uid: '',
};